<rt-activity-subscriptions-table
  [types]="types"
  [title]="'app.subscriptions.follow_candidate_v2' | translate"
>
  <rt-activity-subscriptions-table-row
    icon="pulse"
    [title]="'app.subscriptions.events_group.followed_candidates_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['followedCandidates']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  @if (hasOverdueCandidates) {
    <rt-activity-subscriptions-table-row
      [title]="'app.subscriptions.events_group.followed_candidates_overdue' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['candidateOverdue', 'candidateGoneOverdue']"
      [notifyInfo]="true"
      (changeEvents)="changeEvents.emit($event)"
      icon="alarm"
    >
    </rt-activity-subscriptions-table-row>
  }
  <rt-activity-subscriptions-table-row
    [title]="'app.subscriptions.events_group.candidate_mark_as_hired' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['candidateHired']"
    icon="hired"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  @if (gdprService.gdprSettingEnabled && abilities.manageCandidates) {
    <rt-activity-subscriptions-table-row
      [title]="'app.subscriptions.events_group.candidate_expiring_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['candidateExpiring']"
      (changeEvents)="changeEvents.emit($event)"
      icon="gdpr-candidate"
    >
    </rt-activity-subscriptions-table-row>
  }
</rt-activity-subscriptions-table>
